module.exports = __webpack_public_path__ + "assets/darkTextureplus1Mini.c7cbbae01041925698d3a2a15bc243a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/textures/darkTextureplus1Mini.png
// module id = 180
// module chunks = 0